import * as actions from './actions'

const defaultFamilyDashboardState = {
  isInitializing: true
}

const familyDashboardReducer = (state = defaultFamilyDashboardState, action) => {
  switch(action.type) {
    case(actions.INITIALIZE_FAMILY_DASHBOARD):
      return Object.assign({}, state, { isInitializing: false })
    default:
      return state
  }
}

export default familyDashboardReducer
